var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepositoryMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 11.008 19.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M116.177,163.169a1.179,1.179,0,0,0-1.1.968h-4.876a1.2,1.2,0,0,0-1.1-.968,1.179,1.179,0,0,0-1.1.968h-5.22l1.955-3.313h3.244a1.2,1.2,0,0,0,1.1.968,1.4,1.4,0,0,0,0-2.752,1.179,1.179,0,0,0-1.1.968h-3.587l-.473.79-1.955,3.313h-1.719a1.2,1.2,0,0,0-1.1-.968,1.318,1.318,0,0,0-1.16,1.4,1.276,1.276,0,0,0,1.16,1.376,1.179,1.179,0,0,0,1.1-.968h5.22l2.427,4.128h3.631a1.2,1.2,0,0,0,1.1.968,1.4,1.4,0,0,0,0-2.752,1.179,1.179,0,0,0-1.1.968h-3.287l-1.955-3.313h1.7a1.2,1.2,0,0,0,1.1.968,1.179,1.179,0,0,0,1.1-.968h4.876a1.2,1.2,0,0,0,1.1.968,1.276,1.276,0,0,0,1.16-1.376,1.261,1.261,0,0,0-1.138-1.376Zm-7.067-3.313a.569.569,0,1,1-.473.561A.512.512,0,0,1,109.11,159.856Zm-9.946,5.249a.569.569,0,1,1,.473-.561A.527.527,0,0,1,99.164,165.106Zm13.49,3.007a.569.569,0,1,1-.473.561A.5.5,0,0,1,112.654,168.112Z",
    transform: "translate(170.049 -98.004) rotate(90)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepositoryMenu);
export default __webpack_public_path__ + "static/media/repository_menu.7df3dc88570b33f774d5c434c02c1f1c.svg";
export { ForwardRef as ReactComponent };